export function getLocalDate(date?: string | Date | null) {
    let utcDate = new Date(date || new Date())
    let localTime = utcDate.getTime() - utcDate.getTimezoneOffset() * 60 * 1000
    let localDate = new Date(localTime)
    return localDate
}
